import { useState } from "react";
import { Button, Spinner } from "@swivl-mono/ui";
import { API } from "@swivl-mono/api-helper";
import { AlertsModel } from "../../../Models/Notifications/Alerts.Model";
import { RandomId } from "@swivl-mono/helpers";
import { GoogleSheetImportView } from "./Onboarding.GoogleSheetImport";
import { FMSScrapeView } from "./Onboarding.FMSScrape";
import { WorksheetCustomizationView } from "./Onboarding.WorksheetCustomization";
import { styles } from "./shared/onboarding.styles";

export function OnboardingView() {
    const [orgName, setOrgName] = useState("");
    const [isCreating, setIsCreating] = useState(false);
    const [createdOrg, setCreatedOrg] = useState<any>(null);

    const handleCreateOrg = async () => {
        if (!orgName.trim()) {
            AlertsModel.errorToast("Please enter a name for the org");
            return;
        }

        setIsCreating(true);
        try {
            const allOrgs = await API.Org.getAllOrgs();
            const existingOrgs = allOrgs.filter(org =>
                org.name.toLowerCase() === orgName.trim().toLowerCase()
            );

            if (existingOrgs.length > 0) {
                const orgList = existingOrgs.map(org => {
                    const createdDate = new Date(org.createdAt).toLocaleDateString();
                    return `  • ${org.name}, created ${createdDate}`;
                }).join('\n');

                const message = `The following org with this name already exists:\n\n${orgList}\n\nDo you want to create another org with the same name?`;

                if (!window.confirm(message)) {
                    setIsCreating(false);
                    return;
                }
            }
            const org = await API.Org.createOrg({
                name: orgName,
                parentId: 99,
                isParent: false,
            });

            setCreatedOrg(org);
            AlertsModel.successToast(`Org "${org.name}" created successfully!`);
            await API.LocationVars.createVariable("S3AnalyticsDir", org.name, org.id);
            await API.LocationVars.createVariable("HasFMS", '1', org.id);

            await API.Group.createGroup(org.id, {
                name: orgName,
                orgId: org.id,
            });

            try {
                const chuckInvite = await API.MemberInvite.createInvite(org.id, {
                    email: "chuck@swivl.com",
                    firstName: "Chuck",
                    lastName: "Reina",
                    permissions: [{
                        id: RandomId(4),
                        issued: new Date(),
                        roleSlug: "admin",
                        locations: {
                            orgId: org.id
                        }
                    }]
                });
                await API.MemberInvite.acceptInvite(chuckInvite, 1);
            } catch (chuckError) {
                console.warn("Could not create Chuck member:", chuckError);
                AlertsModel.errorToast("Note: Chuck needs to be added as a member manually");
            }
        } catch (error) {
            console.error("Error creating org:", error);
            AlertsModel.errorToast("Failed to create org");
        } finally {
            setIsCreating(false);
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h1 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '20px' }}>Onboarding</h1>

            <div style={styles.container}>
                <h2 style={styles.heading}>1️⃣ Create New Org</h2>
                <p style={styles.description}>
                    Please submit the name for the new account below:
                </p>

                <div style={{ marginBottom: '20px' }}>
                    <input
                        id="orgName"
                        type="text"
                        value={orgName}
                        onChange={(e) => setOrgName(e.target.value)}
                        placeholder="Enter org name"
                        disabled={isCreating}
                        style={styles.input}
                    />
                </div>

                <div>
                    <Button
                        onClick={handleCreateOrg}
                        disabled={isCreating || !orgName.trim()}
                    >
                        {isCreating ? (
                            <>
                                <Spinner />
                                {' Creating Org...'}
                            </>
                        ) : (
                            "Create Org"
                        )}
                    </Button>
                </div>
            </div>

            {createdOrg && (
                <div style={{ ...styles.successBox, maxWidth: '600px' }}>
                    <h3 style={styles.successHeading}>
                        Org created successfully!
                    </h3>
                    <div style={{ fontSize: '14px', color: '#374151' }}>
                        <p><strong>Name:</strong> {createdOrg.name}</p>
                        <p><strong>Org ID:</strong> {createdOrg.id}</p>
                        <p>Logout and back in to Chuck's account before moving on to step 2!</p>
                    </div>
                </div>
            )}

            <GoogleSheetImportView />

            <FMSScrapeView />

            <WorksheetCustomizationView />
        </div>
    );
}